import ChevronDownIcon from "@/User/Assets/Svgs/ChevronDownPrimaryIcon.svg";
import React from "react";

export const TextNotify = ({ text = "" }) => (
    <span className="bg-pattens-blue-2 px-1 rounded font-normal text-xs text-primary h-5 inline-block leading-normal">{text}</span>
);

const ItemDropdown = ({
    text = "プロフィール 確認・編集",
    onClick = null,
    notify = null,
    isActive = false
}) => (
    <li className={`flex flex-row border-b border-iron p-4 justify-between cursor-pointer ${isActive && "bg-alice-blue-3"} hover:bg-alice-blue-3`} onClick={onClick}>
        <span className="whitespace-normal text-primary leading-7.25 text-xs">{text}</span>
        <div className="flex flex-row items-center">
            {notify && <TextNotify text={notify} />}
            <img src={ChevronDownIcon} className="-rotate-90 w-6 h-6" alt={"Chevron Item Dropdown"} />
        </div>
    </li>
);

export default ({ options = [], isActive = false, afterClick }) => (
    <div id="dropdownNavbar"
        className={`absolute w-375px right-0 top-full p-4 bg-midnight bg-opacity-80 z-999 ${isActive ? "block" : "hidden"}`}>
        <ul className="bg-white">
            {options.map(
                (item, index) =>
                    <ItemDropdown
                        key={index}
                        text={item.text}
                        onClick={() => {
                            item.onClick();
                            afterClick && afterClick();
                        }}
                        notify={item.notify}
                        isActive={item.isActive}
                    />
            )}
        </ul>
    </div>
);
